import jwt_decode from "jwt-decode";

const TOKEN_KEY = "vault_user";

// export const isVcLogin = () => {
//   if (localStorage.getItem("tracid_ng_vc")) {
//     const user = JSON.parse(localStorage.getItem("tracid_ng_vc"));
  
//     if (user) {
//       const decodedJwt = jwt_decode(user.token);

//       if (decodedJwt.exp * 1000 < Date.now()) {
//         return false;
//       }
//     } else {
//       return false;
//     }

//     return true;
//   }

//   return false;
// }

export const isLogin = () => {
  if (localStorage.getItem(TOKEN_KEY)) {
    const user = JSON.parse(localStorage.getItem(TOKEN_KEY));

    if (user) {
      const decodedJwt = jwt_decode(user.token);

      if (decodedJwt.exp * 1000 < Date.now()) {
        return false;
      }
    } else {
      return false;
    }

    return true;
  }

  return false;
};

export const isAdmin = () => {
  if (localStorage.getItem(TOKEN_KEY)) {
    const user = JSON.parse(localStorage.getItem(TOKEN_KEY));

    if (user) {
      const decodedJwt = jwt_decode(user.token);

      if (decodedJwt.exp * 1000 < Date.now()) {
        return false;
      }

      if (decodedJwt.roles.includes("ROLE_ADMIN")) {
        return true;
      }
      return false;
    } else {
      return false;
    }
  }

  return false;
};

export const isConsumer = () => {
  if (localStorage.getItem(TOKEN_KEY)) {
    const user = JSON.parse(localStorage.getItem(TOKEN_KEY));

    if (user) {
      const decodedJwt = jwt_decode(user.token);

      if (decodedJwt.exp * 1000 < Date.now()) {
        return false;
      }

      if (decodedJwt.roles.includes("ROLE_CONSUMER")) {
        return true;
      }
      return false;
    } else {
      return false;
    }
  }

  return false;
};

export const isPlatformManager = () => {
  if (localStorage.getItem(TOKEN_KEY)) {
    const user = JSON.parse(localStorage.getItem(TOKEN_KEY));

    if (user) {
      const decodedJwt = jwt_decode(user.token);

      if (decodedJwt.exp * 1000 < Date.now()) {
        return false;
      }

      if (decodedJwt.roles.includes("ROLE_PLATFORM_MANAGER")) {
        return true;
      }
      return false;
    } else {
      return false;
    }
  }

  return false;
};

export const isUser = () => {
  if (localStorage.getItem(TOKEN_KEY)) {
    const user = JSON.parse(localStorage.getItem(TOKEN_KEY));

    if (user) {
      const decodedJwt = jwt_decode(user.token);

      if (decodedJwt.exp * 1000 < Date.now()) {
        return false;
      }

      if (decodedJwt.roles.includes("ROLE_USER")) {
        return true;
      }
      return false;
    } else {
      return false;
    }
  }

  return false;
};